"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.owUrl = void 0;
var ow_1 = __importDefault(require("ow"));
exports.owUrl = ow_1.default.string.validate(function (val) { return ({
    validator: val.startsWith('http://') || val.startsWith('https://'),
    message: function (label) { return "Expected " + label + " to be an url, got `" + val + "`"; },
}); });
//# sourceMappingURL=ow.types.js.map